<template>
  <div class="home">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <img src="https://res.smoktech.com/files/8e3e3797/ivps_swiper1.png" alt />
        </div>
        <div class="swiper-slide">
          <img src="https://res.smoktech.com/files/c255a96b/ivps_swiper2.png" alt />
        </div>
        <div class="swiper-slide">
          <img src="https://res.smoktech.com/files/c4792af9/ivps_swiper3.png" alt />
        </div>
        <div class="swiper-slide">
          <img src="https://res.smoktech.com/files/5143d7f9/ivps_swiper4.png" alt />
        </div>
        <div class="swiper-slide">
          <img src="https://res.smoktech.com/files/6a12cdc4/ivps_swiper5.png" alt />
        </div>
      </div>
      <!-- Add Arrows -->
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
    </div>
    <div class="cover">
      <img src="https://res.smoktech.com/files/ee16598c/ivps_swiper_bg.png" alt />
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  mounted() {
    var swiper = new Swiper(".swiper-container", {
      nextButton: ".swiper-button-next",
      prevButton: ".swiper-button-prev",
      centeredSlides: true,
      autoplay: 2500,
      loop: true,
      autoplayDisableOnInteraction: false,
      effect: "fade"
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home {
  position: relative;
  width: 332px;
  height: 712px;
  margin: 0 auto;
}

.cover {
  position: absolute;
  top: -19px;
  left: -34px;
  z-index: 100;
  width: 400px;
  height: auto;
  pointer-events: none;
}

img {
  vertical-align: top;
  object-fit: contain;
  width: 100%;
  /* height: 100%; */
}

.swiper-container {
  width: 100%;
  height: 100%;
  background-size: contain;
  position: initial;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.swiper-button-next {
  right: -50px;
  width: 44px;
  background-size: 44px 44px;
  z-index: 101;
  background-image: url("https://res.smoktech.com/files/713aec68/swiper_next.png");
  display: none;
}

.swiper-button-prev {
  left: -50px;
  width: 44px;
  background-size: 44px 44px;
  z-index: 101;
  background-image: url("https://res.smoktech.com/files/7ce4ada7/swiper_prev.png");
  display: none;
}

@media (max-width: 1024px) {
  .home {
    width: 400px;
    height: auto;
  }

  .cover {
    width: 480px;
    left: -40px;
    top: -21px;
  }

  @media (max-width: 480px) {
    .home {
      width: 260px;
    }

    .cover {
      width: 313px;
      top: -14px;
      left: -27px;
    }

    .swiper-button-next,
    .swiper-button-prev {
      width: 34px;
      background-size: 34px 34px;
    }

    .swiper-button-next {
      right: -35px;
      display:none;
    }

    .swiper-button-prev {
      left: -35px;
      display:none;
    }

    @media (max-width: 340px) {
      .home {
        width: 212px;
      }

      .cover {
        width: 255px;
        top: -12px;
        left: -22px;
      }
    }
  }
}
</style>
